export const STICKY_BOTTOM_SHADOW_STUCK_OFFSET = 1
